module.exports = __webpack_public_path__ + "assets/img/f11.acd6a236.png";